'use strict';
const assetFileIdFromS3Key = function (s3Key) {
		return s3Key.split('/').pop();
	},
	GoldFileHistoryEventImpl = require('@mindmup/mindmup-common/src/gold-file-history-event'),
	GoldFileChangesEnvelopeBuilderImpl = require('@mindmup/mindmup-common/src/gold-file-changes-envelope-builder'),
	fileItemDecorator = require('./file-item-decorator');
module.exports = function S3FileModel(config, authentication, goldApi, s3Api, navigatorShim, defaultMapContent, optional) {
	if (!config || !authentication || !goldApi || !s3Api || !navigatorShim || !defaultMapContent) {
		throw 'invalid-args';
	}

	const obj = this,
		clientSecret = optional && optional.clientSecret,
		GoldFileHistoryEvent = (optional && optional.GoldFileHistoryEvent) || GoldFileHistoryEventImpl,
		GoldFileChangesEnvelopeBuilder = (optional && optional.GoldFileChangesEnvelopeBuilder) || GoldFileChangesEnvelopeBuilderImpl,
		freeMapTitle = config.freeMapTitle || 'Free mind map',
		goldFileApi = (optional && optional.goldFileApi) || require('./gold-file-api'),
		getLicense = async () => {
			const license = await authentication.authenticationModel.getLicense();
			if (license) {
				return {license};
			}
			throw 'not-authenticated';
		},
		getLicenseAndAffiliateTeamIdentity = async (refreshCache) => {
			const licenseParams = await getLicense(),
				affiliateTeamIdentity = await authentication.affiliateTeamIdentityProvider?.getAffiliateTeamIdentity(),
				ids = Object.assign(licenseParams, {affiliateTeamIdentity});
			if (affiliateTeamIdentity && refreshCache) {
				try {
					await goldApi.exec('subteam/affiliate/cache_teams', ids);
				} catch (e) {
					console.error(e);
				}
			}
			return ids;
		},
		legacyFreeFileLoadConfig = function (pathInfo) {
			const url = config.legacyFreeUrl + encodeURIComponent(pathInfo.fileId);
			return {
				title: freeMapTitle,
				url: url
			};
		},
		freeFileLoadConfig = function (pathInfo) {
			return goldApi.exec('anonymous/url', {fileKey: pathInfo.fileId})
			.then((url) => {
				return {
					title: freeMapTitle,
					url: url
				};
			});
		},
		generateSaveConfiguration = function (pathInfo, ids) {
			const license = ids && ids.license,
				fileId = goldFileApi.goldFileKey(pathInfo, license),
				params = Object.assign({}, ids, {fileId});
			return goldApi.exec('file/upload_config', params);
		},

		goldFileLoadConfig = async pathInfo => {
			const ids = await getLicenseAndAffiliateTeamIdentity(true),
				fileKey = goldFileApi.goldFileKey(pathInfo, ids.license),
				execParams = Object.assign({fileKey, clientSecret}, ids),
				loadConfig = await goldApi.exec('file/load_config', execParams),
				title = (loadConfig && loadConfig.metadata && loadConfig.metadata.description) || 'MindMup Gold';
			return Object.assign(loadConfig, {title});
		},
		goldFileShareLoadConfig = pathInfo => {
			return goldApi.exec('file/shared_gold_load_config', {email: pathInfo.email, fileId: pathInfo.fileId, signature: pathInfo.signature})
			.then(loadConfig => {
				const title = loadConfig && loadConfig.metadata && loadConfig.metadata.description;
				loadConfig.title = title || 'MindMup Gold';
				return loadConfig;
			});
		},
		startSession = (ids, pathInfo) => {
			if (!ids || !ids.license) {
				throw 'not-authenticated';
			}
			if (!pathInfo) {
				return Promise.reject(new Error('invalid-args'));
			}

			const params = Object.assign({
				clientSecret,
				fileKey: goldFileApi.goldFileKey(pathInfo, ids.license)

			}, ids);
			return goldApi.exec('file/session/start', params);
		},
		deleteFile = function (ids, pathInfo, envelope) {
			if (!ids || !ids.license) {
				throw 'not-authenticated';
			}
			if (!pathInfo || pathInfo.new || pathInfo.free || pathInfo.legacy) {
				return Promise.reject(new Error('invalid-args'));
			}
			const fileKey = goldFileApi.goldFileKey(pathInfo, ids.license);
			return goldApi.exec('file/delete', Object.assign({fileKey, envelope}, ids));
		},
		undeleteFile = function (ids, pathInfo, envelope) {
			if (!ids || !ids.license) {
				throw 'not-authenticated';
			}
			if (!pathInfo || pathInfo.new || pathInfo.free || pathInfo.legacy) {
				return Promise.reject(new Error('invalid-args'));
			}
			const fileKey = goldFileApi.goldFileKey(pathInfo, ids.license);
			return goldApi.exec('file/undelete', Object.assign({fileKey, envelope}, ids));
		};

	obj.getLoadConfig = function (pathInfo) {
		if (!pathInfo) {
			return Promise.reject('invalid-args');
		}
		if (pathInfo.new) {
			return Promise.resolve({title: config.defaultFileTitle});
		}
		if (!pathInfo.fileId) {
			return Promise.reject('invalid-args');
		}
		if (pathInfo.free) {
			return freeFileLoadConfig(pathInfo);
		}
		if (pathInfo.goldFileShare) {
			return goldFileShareLoadConfig(pathInfo);
		}
		if (pathInfo.legacy) {
			return Promise.resolve(legacyFreeFileLoadConfig(pathInfo));
		}
		return goldFileLoadConfig(pathInfo);
	};

	obj.getClientSecret = () => clientSecret;

	obj.generateImportMapConfiguration = function (convertFromType) {
		return getLicense()
		.then((ids) => {
			return goldApi.exec('file/import_map/upload_config', Object.assign({}, ids, {convertFromType}));
		});
	};

	obj.loadChangesHistoryFile = (signedUrl, callOptions) => {
		if (!signedUrl) {
			throw new Error('invalid-args');
		}
		return s3Api.loadUrl(signedUrl, Object.assign({includeHeaders: true, cache: 'no-store'}, callOptions));
	};

	obj.loadFile = function (pathInfo, loadConfig) {
		if (!pathInfo || !loadConfig) {
			return Promise.reject('invalid-args');
		}
		if (pathInfo.new) {
			if (pathInfo.theme) {
				return Promise.resolve(Object.assign({}, defaultMapContent, {attr: {theme: pathInfo.theme}}));
			}
			return Promise.resolve(defaultMapContent);
		}
		const loadFrom = (optional && optional.useWatermark && loadConfig.hasWatermark && loadConfig.watermarkUrl) || loadConfig.url;
		return s3Api.loadUrl(loadFrom)
		.then(content => {
			if (typeof content === 'string') {
				return JSON.parse(content);
			}
			return content;
		})
		.catch((reason) => {
			if (pathInfo && pathInfo.free && reason === 'not-found') {
				throw 'free-map-not-found';
			} else {
				throw reason;
			}
		});
	};

	obj.renameFile = async (pathInfo, newName) => {
		if (!pathInfo || !newName || pathInfo.new || pathInfo.free || pathInfo.legacy) {
			return Promise.reject('invalid-args');
		}
		const ids = await getLicense(),
			fileId = goldFileApi.goldFileKey(pathInfo, ids.license);
		return goldApi.exec('file/rename', Object.assign({fileId, newName}, ids));
	};

	obj.validFreeFileContent = function (content) {
		if (config && config.maxFreeSize && content.length >= config.maxFreeSize) {
			return Promise.reject('file-too-large');
		}
		return Promise.resolve(content);
	};

	obj.freeFileSaveConfiguration = function (pathInfo) {
		return generateSaveConfiguration(pathInfo);
	};
	obj.goldFileChangesSaveConfiguration = async (pathInfo, sessionId) => {
		const ids = await getLicense(),
			params = Object.assign({
				fileKey: goldFileApi.goldFileKey(pathInfo, ids.license),
				sessionId: sessionId
			}, ids);
		return goldApi.exec('file/changes/upload_config', params);
	};
	obj.getHistoryFileUrl = async (pathInfo, callOptions) => {
		if (!pathInfo || pathInfo.free || pathInfo.new) {
			throw new Error('invalid-args');
		}
		const ids = await getLicense(),
			fileKey = goldFileApi.goldFileKey(pathInfo, ids.license),
			params = Object.assign({fileKey}, callOptions, ids);
		return goldApi.exec('file/changes/history_download_url', params);
	};
	obj.unaggregatedChanges = async (pathInfo, callOptions) => {
		if (!pathInfo) {
			throw new Error('invalid-args');
		}
		if (pathInfo.free || pathInfo.new) {
			return Promise.resolve(false);
		}
		const ids = await getLicense(),
			fileKey = goldFileApi.goldFileKey(pathInfo, ids.license),
			params = Object.assign({
				fileKey,
				maxFiles: 20
			}, callOptions, ids);
		return goldApi.exec('file/changes/unaggregated', params);
	};
	obj.startSession = async pathInfo => {
		const ids = await getLicense();
		return startSession(ids, pathInfo);
	};
	obj.endSession = async (pathInfo, sessionId) => {
		const ids = await getLicense(),
			params = Object.assign({
				fileKey: goldFileApi.goldFileKey(pathInfo, ids.license),
				sessionId
			}, ids);
		return goldApi.exec('file/session/end', params);

	};

	obj.goldFileSaveConfiguration = async pathInfo => {
		const ids = await getLicense(),
			saveConfiguration = await generateSaveConfiguration(pathInfo, ids);
		if (saveConfiguration.free) {
			throw 'not-authenticated';
		}
		return saveConfiguration;
	};

	obj.saveFreeFile = async (saveConfiguration, content) => {
		await s3Api.save(content, saveConfiguration);
		return saveConfiguration;
	};

	obj.saveGoldFile = async (saveConfiguration, contentToSave) => {
		const content = typeof contentToSave === 'string' ? contentToSave : JSON.stringify(contentToSave);

		await s3Api.save(content, saveConfiguration);
		return saveConfiguration;
	};

	obj.savedFileInfo = function (saveConfiguration) {
		const savedFileId = goldFileApi.fileIdFromSaveConfig(saveConfiguration),
			results =  {
				savedFileId: savedFileId,
				savedUrl: goldFileApi.calculateFileUrl(config.editorUrl, savedFileId, saveConfiguration.free)
			};
		if (saveConfiguration.allowedActions) {
			results.allowedActions = saveConfiguration.allowedActions;
		}
		return results;
	};

	obj.createFile = function (fileName, folderId, content) {
		const pathInfo = {
			new: true,
			title: fileName
		};
		return obj.goldFileSaveConfiguration(pathInfo)
		.then((saveConfiguration) => obj.saveGoldFile(saveConfiguration, content))
		.then((saveConfiguration) => obj.savedFileInfo(saveConfiguration))
		.then((savedFileInfo) => {
			savedFileInfo.id = '_v2/' + savedFileInfo.savedFileId;
			return savedFileInfo;
		});
	};
	obj.deleteFile = async (pathInfo, envelope) => {
		if (!pathInfo || pathInfo.new || pathInfo.free || pathInfo.legacy) {
			throw new Error('invalid-args');
		}
		const ids = await getLicense();
		return deleteFile(ids, pathInfo, envelope);
	};

	obj.deleteFileListItem = async pathInfo => {
		if (!pathInfo || !pathInfo.fileId || pathInfo.version !== 2) {
			throw new Error('invalid-args');
		}
		const ids = await getLicense(),
			sessionId = await startSession(ids, pathInfo),
			sessionIdRetriever = () => sessionId,
			goldFileHistoryEvent = new GoldFileHistoryEvent(sessionIdRetriever),
			envelopeBuilder = new GoldFileChangesEnvelopeBuilder(authentication.authenticationModel, sessionIdRetriever),
			evt = goldFileHistoryEvent.buildLocalControlEvent('trashed', [true]),
			envelope = await envelopeBuilder.nextEnvelope([evt]);
		return deleteFile(ids, pathInfo, envelope);
	};

	obj.undeleteFile = async (pathInfo, envelope) => {
		if (!pathInfo || pathInfo.new || pathInfo.free || pathInfo.legacy) {
			return Promise.reject(new Error('invalid-args'));
		}
		const ids = await getLicense();
		return undeleteFile(ids, pathInfo, envelope);
	};

	obj.undeleteFileListItem = async pathInfo => {
		if (!pathInfo || !pathInfo.fileId || pathInfo.version !== 2) {
			return Promise.reject(new Error('invalid-args'));
		}
		const ids = await getLicense(),
			sessionId = await startSession(ids, pathInfo),
			sessionIdRetriever = () => sessionId,
			goldFileHistoryEvent = new GoldFileHistoryEvent(sessionIdRetriever),
			envelopeBuilder = new GoldFileChangesEnvelopeBuilder(authentication.authenticationModel, sessionIdRetriever),
			evt = goldFileHistoryEvent.buildLocalControlEvent('trashed', [false]),
			envelope = await envelopeBuilder.nextEnvelope([evt]);
		return undeleteFile(ids, pathInfo, envelope);
	};

	obj.fileItemDecorator = fileItem => {
		return getLicense()
		.then(ids => fileItemDecorator(ids.license, fileItem));
	};
	obj.listFiles = async () => {
		const ids = await getLicenseAndAffiliateTeamIdentity(true),
			downloadUrl = await	goldApi.exec('file/list_config', ids),
			result = await s3Api.loadUrl(downloadUrl),
			notTrashedUnownedFile = (file) => !(!file.context.recycleBin && file.trashTs);
		return result.list.map(item => fileItemDecorator(ids.license, item)).filter(notTrashedUnownedFile);
	};

	obj.buildSavedList = async () => {
		const ids = await getLicense();
		return goldApi.exec('file/build_saved_list', ids);
	};
	obj.requestWatermarkForFileKey = async function (fileKey, force) {
		const licenseParams = await getLicense(),
			params = Object.assign({}, licenseParams, {fileKey, force});
		return goldApi.exec('file/request_watermark', params);
	};

	obj.requestWatermark = async function (pathInfo) {
		const licenseParams = await getLicense(),
			fileKey = goldFileApi.goldFileKey(pathInfo, licenseParams.license);
		return obj.requestWatermarkForFileKey(fileKey, false);
	};

	obj.createPublicUrl = async ({fileKey, password, timeLimitHours, accessLevel}) => {
		const licenseParams = await getLicense(),
			params = {
				license: licenseParams.license,
				fileKey,
				password,
				timeLimitHours,
				accessLevel
			};
		return goldApi.exec('file/crowdlink/create', params);
	};
	obj.removePublicUrl = async ({fileKey}) => {
		const licenseParams = await getLicense(),
			params = {
				license: licenseParams.license,
				fileKey
			};
		return goldApi.exec('file/crowdlink/remove', params);
	};
	obj.getPublicUrl = async ({fileKey}) => {
		const licenseParams = await getLicense(),
			params = {
				license: licenseParams.license,
				fileKey
			};
		return goldApi.exec('file/crowdlink/get', params);
	};
	obj.updateTag = async (action, fileKey, tag) => {
		const ids = await getLicense(),
			params = Object.assign({tag, fileKey}, ids);
		return goldApi.exec('file/tag/' + action, params);
	};
	obj.uploadAsset = async (mapId, assetUrl, callOptions) => {
		if (!mapId || !assetUrl) {
			throw new Error('invalid-args');
		}

		const ids = await getLicense(),
			buildUploadParams = (contentBlob) => {
				const mimeType = contentBlob && contentBlob.type,
					params = Object.assign({mapId, mimeType}, ids);
				if (callOptions?.isThumbnail) {
					params.assetKey = 'thumbnail.png';
				}
				return params;
			},
			doUpload = async () => {
				const contentBlob =  navigatorShim.dataURLToBlob(assetUrl),
					params = buildUploadParams(contentBlob),
					uploadConfig = await goldApi.exec('asset/upload_config', params),
					assetId = assetFileIdFromS3Key(uploadConfig.key);
				await s3Api.save(contentBlob, uploadConfig);
				return assetId;
			};
		return doUpload();
	};

	obj.getAssetUrls = async (mapId, assetIds, pathInfo) => {

		if (!mapId || !assetIds) {
			return Promise.reject(new Error('invalid-args'));
		}

		if (pathInfo && pathInfo.goldFileShare && pathInfo.email && pathInfo.signature) {
			return goldApi.exec('asset/shared_gold_download_config', {email: pathInfo.email, mapId: mapId, signature: pathInfo.signature, assetIds: assetIds});
		}
		if (!assetIds.length) {
			return {};
		}

		const ids = await getLicense();
		return goldApi.exec('asset/download_config', Object.assign({mapId, assetIds}, ids));
	};

	obj.getSharedWith = async (fileId) => {
		if (!fileId) {
			throw new Error('invalid-args');
		}
		const ids = await getLicense();
		return goldApi.exec('file/shared_with_complete', Object.assign({fileId}, ids));
	};
	obj.shareWith = async (fileId, share) => {
		if (!fileId || !share) {
			throw new Error('invalid-args');
		}
		const ids = await getLicense();
		return goldApi.exec('file/share', Object.assign({fileId, share}, ids));
	};

	obj.shareWithSubteam = async (fileId, teamId, role) => {
		if (!fileId || !teamId) {
			throw new Error('invalid-args');
		}
		const ids = await getLicense();
		return goldApi.exec('file/share_with_subteam', Object.assign({fileId, teamId, role}, ids));
	};

	obj.removeOwnShare = async (fileId) => {
		if (!fileId) {
			throw new Error('invalid-args');
		}
		const ids = await getLicense();
		return goldApi.exec('file/remove_share_pointer', Object.assign({fileId}, ids));

	};
};

